module.exports = __webpack_public_path__ + "static/media/MANAS 2.0354bd00.jpg";